
<router-outlet></router-outlet>
<p-toast position="bottom-center" styleClass="nx-app-toast">
  <ng-template let-message pTemplate="message">
    <div class="nx-toast flex flex-row justify-between w-full items-center">
      <div class="nx-toast">
        {{ message.data?.message | translate }}
      </div>
      <div *ngIf="message.data?.action" class="flex flex-row justify-end grow">
        <nx-default-button
          style="transparent"
          [label]="message.data?.actionLabel"
          (clicked)="onToastAction(message)"></nx-default-button>
      </div>
    </div>
  </ng-template>
</p-toast>
